export default function categoriesList({main, on, elm}) {
    main(() => {
        on('mouseover', '.cars__list', changeSlide);
    });

    const changeSlide = function(e) {
        const item = e.target.closest('.cars__item');
        if (!item) return;

        const index = item.dataset.index;
        const swiper = elm.querySelector('.swiper').swiper;
        swiper.slideTo(index, 400);
    };
};

export const model = {};
